import React from "react";
import ServiceCardWrap from "./ServiceCardWrap";

function ServiceWrap() {
  return (
    <>
      <ServiceCardWrap />
      {/* <ClientTestimonial />
      <PriceCardWrap /> */}
    </>
  );
}

export default ServiceWrap;
